/**
 * DataLayer JS for dataLayer.push
 *
 */

/**
 * Require $.
 */

var $ = require('jquery');

module.exports = function () {

    // Main and Eyebrow Nav
    const header = document.querySelector(".header");

    header.addEventListener("click", function (event) {
        if (!event.target.closest(".secondary-menu-item, .main-menu-item-parent"))
            return;
    
        const menuItemName = event.target.innerText;
    
        if (!dataLayer) return;
    
        const prefix = event.target.closest(".secondary-menu-item")
            ? "Eyebrow"
            : "Main";
    
        const pushVars = {
            event: `${prefix}-Menu-Nav`,
            menuItem: menuItemName,
        };
    
        dataLayer.push(pushVars);
    });

    // Form submit event for webinar and industry resource
    $('body').on('submit', 'form.hs-form', function() {
        var $form = $(this);
        var formData = $form.serializeArray($form);
        var currentUrl = window.location.href;
        var eventTitle = '';
        var pageName = '';
        
        if (currentUrl.includes('/webinar/')) {
            eventTitle = 'Webinar Register';
            pageName = 'Webinar';
 
        } else if (currentUrl.includes('/industry-resource/')) {
            eventTitle = 'Industry Resource Download';
            pageName = 'Industry Resource';
        }
        if(dataLayer){
            let pushVars = {
                'event': eventTitle,
                'pageName': pageName,
                'pageUrl': currentUrl,
                'formData': formData,
            };
            dataLayer.push(pushVars);
        }

    })

    // Article - Teaser Clicked
    let teaser = document.querySelector('.main-content .teaser')
    if ( teaser !== null ) {
        teaser.addEventListener('click', function( event ) {
            if( teaser.contains( event.target ) ) {
                if(dataLayer) {
                    let pushVars = {
                        'event': 'Post-Element-Click',
                        'pageName': POSTDATA.post_name,
                        'pageUrl': POSTDATA.permalink,
                    }
                    dataLayer.push(pushVars)
                }
            }
        })
    }
};
